import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { history } from '@collaborator/npm_modules/dist/components/redux/store';

var sentryInit = function sentryInit(dsn, sampleRate, normalizeDepth) {
  Sentry.init({
    dsn: dsn,
    allowUrls: [window.location.origin],
    beforeSend: function beforeSend(event) {
      if (event.exception.values.length) {
        var value = event.exception.values[0].value;

        if (value.match(/^ym is not defined$/) || value.match(/^Can't find variable: ym$/) || value.match(/^ResizeObserver loop completed with undelivered notifications.$/) || value.match(/^ResizeObserver loop limit exceeded$/)) {
          return null;
        }
      }

      return event;
    },
    integrations: [new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history)
    })],
    tracesSampleRate: sampleRate,
    normalizeDepth: normalizeDepth
  });
};

export { sentryInit };